import React, { useEffect, useRef } from "react";

// Renders an invisible div that triggers `onVisible` when it scrolls
// into view. Used by wall widgets to support infinite scroll.
//
// Props:
//   onVisible    - callback fired when sentinel enters viewport
//   loading      - render a small spinner while a fetch is in flight
//   exhausted    - render nothing once all proofs are loaded
//   color        - spinner color (defaults to slate)
const LoadMoreSentinel = ({ onVisible, loading, exhausted, color = "#64748b" }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (exhausted || !onVisible) return undefined;
    const node = ref.current;
    if (!node) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) onVisible();
        });
      },
      { rootMargin: "200px 0px" }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [onVisible, exhausted]);

  if (exhausted) return null;

  return (
    <div ref={ref} className="w-full flex items-center justify-center py-8">
      {loading && (
        <svg className="animate-spin h-6 w-6" viewBox="0 0 24 24" fill="none" style={{ color }}>
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
        </svg>
      )}
    </div>
  );
};

export default LoadMoreSentinel;
